module.exports = __webpack_public_path__ + "media/18.9864e71d.mp3";